<div>
  <div>
    <div style="text-align: center">
      <h2>
        We're sorry. We're currently exploring the root cause of this unplanned
        downtime.
      </h2>
      <p>Please plan to try again later.</p>
    </div>
  </div>
</div>
